import { Box, Link, Spinner } from '@chakra-ui/react';
import { eclaireurPath, ECLAIREURS_MOBILITE_GROUP_PATH } from 'lib/paths';
import EclaireurItem from './EclaireurItem';
import Slider from 'components/general/Slider';
import PropTypes from 'prop-types';
import LinkButton from 'components/general/LinkButton';
import { useEclaireurMobiliteGroup } from 'lib/hooks';
import { useRouter } from 'next/router';
import { GroupEclaireur } from '@inspire/data/static/user';
import {
  GTM_ACTION_ECLAIREUR_TU_PENSES_DEMENAGER_VOIR_PROFIL,
  GTM_CATEGORY_ECLAIREURS,
  pushEvent,
} from 'lib/gtm';

const EclaireursMobiliteGroupContact = ({
  areEclaireursLoading,
  eclaireurs,
}) => {
  const { setEclaireurMobiliteGroup, setEclaireurMobiliteGroupAsync } =
    useEclaireurMobiliteGroup();
  const { push } = useRouter();

  const currentGroup: GroupEclaireur = 'Mobilité';

  return (
    <>
      {areEclaireursLoading ? (
        <Spinner m={4} size="xl" thickness="4px" />
      ) : (
        <>
          <Slider>
            {eclaireurs?.map((e, i) => (
              <Box key={e._id} pos="relative" role="group" p={4}>
                <Link
                  key={i}
                  style={{ textDecoration: 'none' }}
                  onClick={async () => {
                    await setEclaireurMobiliteGroupAsync(true);
                    push({
                      pathname: `${eclaireurPath(e._id)}`,
                      query: { group: currentGroup },
                    });
                    pushEvent(
                      GTM_CATEGORY_ECLAIREURS,
                      GTM_ACTION_ECLAIREUR_TU_PENSES_DEMENAGER_VOIR_PROFIL,
                      e._id
                    );
                  }}
                >
                  <EclaireurItem eclaireur={e} group={currentGroup} />
                </Link>
              </Box>
            ))}
          </Slider>
          <Box textAlign="center">
            <LinkButton
              m={4}
              href={ECLAIREURS_MOBILITE_GROUP_PATH}
              onClick={async () => {
                setEclaireurMobiliteGroup(true);
              }}
            >
              Voir plus d'Éclaireurs
            </LinkButton>
          </Box>
        </>
      )}
    </>
  );
};

EclaireursMobiliteGroupContact.propTypes = {
  areEclaireursLoading: PropTypes.bool.isRequired,
  eclaireurs: PropTypes.array,
};

export default EclaireursMobiliteGroupContact;
